module.exports = __webpack_public_path__ + "media/parents/bullet-92fbfe0a.gif";